import { auth, ref } from 'constants/firebase'
import firebase from 'firebase'
import { logoutAction } from 'actions/authAC'
import { displayError, displayStandard, displaySuccess } from '../components/NotificationController'
import { saveUserAttributes } from './user'
import config from 'config'

export function authAnonymously () {
  return function * (dispatch, getState) {
    try {
      const authData = yield auth.signInAnonymously()
      console.log('anonymous signin ok', authData)
    } catch (e) {
      console.log('anonymous signin error', e)
    }
  }
}

export function callFacebookLogin () {
  return function * (dispatch, getState) {
    const provider = new firebase.auth.FacebookAuthProvider()
    try {
      const authData = yield auth.signInWithPopup(provider)
      console.log('facebook login ok', authData)
    } catch (e) {
      // console.log('facebook login error', e)
    }
  }
}

export function callGoogleLogin () {
  return function * (dispatch, getState) {
    console.log('callGoogleLogin')
    const provider = new firebase.auth.GoogleAuthProvider()
    try {
      const authData = yield auth.signInWithPopup(provider)
      console.log('google login ok', authData)
    } catch (e) {
      console.log('google login error', e)
    }
  }
}

export function logout () {
  return function * (dispatch, getState) {
    try {
      yield auth.signOut()
      dispatch(logoutAction())
    } catch (e) {
      console.log('signOut error', e)
    }
  }
}

export function signInByEmailPassword (values) {
  return function * (dispatch, getState) {
    try {
      yield auth.signInWithEmailAndPassword(values.email, values.password)
    } catch (error) {
      if (error) {
        console.log('errorrrrr  coooodooee ee  ', error.code)
        switch (error.code) {
          case 'auth/invalid-email':
            console.log('The specified user account email is invalid.')
            displayError('The specified user account email is invalid.')
            break
          case 'auth/wrong-password':
            console.log('The specified user account password is incorrect.')
            displayError('The specified user account password is incorrect.')
            break
          case 'auth/user-not-found':
            console.log('The specified user account does not exist.')
            displayError('The specified user account does not exist.')
            break
          case 'auth/user-disabled':
            console.log('The specified user account is disabled.')
            displayError('The specified user account is disabled.')
            break
          default:
            console.error('Error logging user in:', error)
        }
      }
    }
  }
}

export function signUp (values) {
  return function * (dispatch, getState) {
    try {
      // console.log('[SignUp] signUp with values', values)
      const userData = yield auth.createUserWithEmailAndPassword(values.signUpEmail, values.signUpPassword)
      // console.log('[SignUp] Successfully created user account with uid:', userData.uid)
      yield auth.signInWithEmailAndPassword(values.signUpEmail, values.signUpPassword)
      console.log('[SignUp] Successfully signInWithEmailAndPassword')

      if (values.fullName && values.companyName) {
        yield saveUserAttributes(userData.uid, values.fullName, values.companyName)
        // console.log('[SignUp] Successfully save user attrs', values.fullName, values.companyName)
      }
    } catch (error) {
      console.log('SIGNUP errorrrrr  coooodooee ee  ', error.code)
      switch (error.code) {
        case 'auth/email-already-in-use':
          console.log('This email is already in use.')
          displayError('This email is already in use.')
          break
        case 'auth/invalid-email':
          console.log('The specified email is not a valid email.')
          displayError('The specified email is not a valid email.')
          break
        case 'auth/operation-not-allowed':
          console.log('Operation is not allowed.')
          displayError('Operation is not allowed.')
          break
        case 'auth/weak-password':
          console.log('The specified password is not strong enough.')
          displayError('The specified password is not strong enough.')
          break
        default:
          console.log('SighUp error:', error)
          displayError(error.message)
      }
    }
  }
}

export function sendPasswordResetEmail (email) {
  return function * (dispatch, getState) {
    try {
      yield auth.sendPasswordResetEmail(email, {url: `${config.staticURL}/dashboard`})
      displayStandard('Follow the instructions those have been sent to your email')
    } catch (error) {
      if (error && error.code) {
        switch (error.code) {
          case 'auth/user-not-found':
            displayError('There is no user corresponding to the email address')
            break

          case 'auth/invalid-email':
            displayError('The email address is not valid')
            break

          default :
            displayError(error.message)

        }
      }
    }
  }
}

export function changeEmailPassword (newEmail, oldPassword, newPassword) {
  return function * (dispatch, getState) {
    try {
      const email = auth.currentUser.email
      if (email === newEmail && oldPassword === newPassword) {
        return
      }
      const cred = firebase.auth.EmailAuthProvider.credential(email, oldPassword)
      yield auth.currentUser.reauthenticateWithCredential(cred)
      if (email !== newEmail) {
        yield auth.currentUser.updateEmail(newEmail)
        yield ref.child('users').child(auth.currentUser.uid).child('email').set(newEmail)
      }
      if (oldPassword !== newPassword) {
        yield auth.currentUser.updatePassword(newPassword)
      }
      displaySuccess('Successfully updated')
    } catch (error) {
      if (error && error.code) {
        switch (error.code) {
          case 'auth/user-not-found':
            displayError('There is no user corresponding to the email address')
            break

          case 'auth/invalid-email':
            displayError('The email address is not valid')
            break

          default :
            displayError(error.message)

        }
      } else {
        console.error(error)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/controllers/auth.js